<!--  -->
<template>
  <EDialog
    dialog-title="查看详情"
    :center-dialog-visible="materialsVisible"
    popup-width="960px"
    show-close-btn
    :show-btn="false"
    @resetPopupData="onCancel"
  >
    <div class="dialog-content">
      <TableList
              ref="leftTableRef"
              :table-data="tableData"
              :table-label="tableLabel"
              :loading="tableLoading"
              maxHeight="360"
              index-show
      ></TableList>
      <div class="pagination">
        <el-pagination
          :pager-count="5"
          layout="total, prev, pager, next"
          :current-page="listQuery.pageNum"
          :total="total"
          :page-size.sync="listQuery.pageSize"
          prev-text="上一页"
          next-text="下一页"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </div>
  </EDialog>
</template>

<script>
import EDialog from '@/modules/projectA/components/common/e-dialog.vue';
import TableList from '@/modules/projectA/components/common/e-table-list.vue';
import api from '@/modules/projectA/api/order';
import { detailLabel as tableLabel } from '../../common/stockOrder';

export default {
  components: {
    EDialog,
    TableList,
  },
  props: {
    visible: Boolean,
    purchasePlanId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      total: 0,
      tableLabel,
      tableData: [],
      tableLoading: true,
      listQuery: {
        pageNum: 1,
        pageSize: 10,
      },
    };
  },
  computed: {
    materialsVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      },
    },
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.listQuery.pageNum = 1;
        setTimeout(() => {
          this.getList();
        }, 500);

      }
    },
  },
  methods: {
    onCancel() {
      this.materialsVisible = false;
    },
    async getList(listQuery) {
      try {
        this.tableLoading = true;
        const { purchasePlanId } = this;
        const {code, data = {}} = await api.ecPurchasePlanSkuQueryPage({purchasePlanId, ...listQuery});
        if (code === '200') {
          const { records = [], total = 0 } = data;
          this.tableData = [...records];
          this.total = total;
          this.tableLoading = false;
        }
      } catch (error) {
        console.error(error);
        // this.tableData = [];
      } finally {
        this.tableLoading = false;
      }
    },
    handleCurrentChange(num) {
      this.tableLoading = true;
      this.listQuery.pageNum = num;
      this.getList(this.listQuery);
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-radio__label {
  display: none;
}
</style>
